

$(window).scroll(function () {
    var testlp = !!document.getElementById("LP");
    var testsummary = !!document.getElementById("summary-stick");
    if ((testsummary == true) && (testlp == false)) {

        let hauteur = document.documentElement.scrollHeight - window.innerHeight;
        let position = window.scrollY;


        let barre = (position / hauteur) * 100;

        document.getElementById("barre").style.width = barre + "%";


        if ($(window).scrollTop() > $(".origami-head").height() + 30) {
            $("#summary-stick").addClass("is-sum-stick");
            $("#summary-stick").removeClass("col-12");
            $("#summary-stick").removeClass("col-lg-6");
            $(".menu-sticky").fadeIn("slow");
        }


        if ($(window).scrollTop() < $(".origami-head").height() + 30) {
            $("#summary-stick").removeClass("is-sum-stick");
            $("#summary-stick").addClass("col-12");
            $("#summary-stick").addClass("col-lg-6");
        }

    }

    if ((testsummary == true) && (testlp == true)) {

        let hauteur = document.documentElement.scrollHeight - window.innerHeight;
        let position = window.scrollY;


        let barre = (position / hauteur) * 100;

        document.getElementById("barre").style.width = barre + "%";




        if ($(window).scrollTop() > $(".header_agpm_lp").height() + 30) {
            $("#summary-stick").addClass("is-sum-stick");
            $("#summary-stick").removeClass("container");
            $(".menu-sticky").fadeIn("slow");
        }


        if ($(window).scrollTop() < $(".header_agpm_lp").height() + 30) {
            $("#summary-stick").removeClass("is-sum-stick");
            $("#summary-stick").addClass("container");
        }

    }
});


function RemoveClassLP() {
    var sliders = document.getElementsByClassName("ancres");
    for (var i = 0; i < sliders.length; i++) {
        document.getElementById("S-" + sliders[i].id).classList.remove("selected");
    }
}


function ChangeSummaryLP() {

    var slides = document.getElementsByClassName("ancres");
    for (var i = 0; i < slides.length; i++) {

        if (typeof lastslide === 'undefined') {

            if ((window.scrollY > document.getElementById(slides[i].id).offsetTop - 5)) {

                RemoveClassLP();
                document.getElementById("S-" + slides[i].id).classList.add("selected");

                lastslide = slides[i].id;
            }

        }
        else {
            if (lastslide != slides[i].id) {
                /*alert(lastslide+'->'+slides[i].id);*/
                if ((window.scrollY > document.getElementById(slides[i].id).offsetTop - 5)) {

                    RemoveClassLP();
                    document.getElementById("S-" + slides[i].id).classList.add("selected");

                    lastslide = slides[i].id;

                }


            }

        }

    }

}



var summerClic = document.querySelectorAll("ul#summary-stick-ul li");

document.addEventListener('DOMContentLoaded', function () {



    var testlp = !!document.getElementById("LP");
    var testsummary = !!document.getElementById("summary-stick");

    let hauteur = document.documentElement.scrollHeight - window.innerHeight;
    let position = window.scrollY;


    let barre = (position / hauteur) * 100;


    if ((testsummary == true) && (testlp == true)) {

        const Ssummer = window.addEventListener('scroll', function () {

                ChangeSummaryLP()
            }
        );


    }
});
